import {
  defaultTo,
  either,
  find,
  lensPath,
  lensProp,
  pipe,
  propEq,
  set,
  view,
} from "ramda";
import { APP_ERROR, APP_DATA_LOADED, APP_STARTED } from "./applicationActions";

const initialState = {
  error: {},
  project: {},
  organization: {},
};

const errorLens = lensProp("error");
const setError = set(errorLens);
export const getError = view(errorLens);

const projectLens = lensProp("project");
const setProject = set(projectLens);
export const getProject = view(projectLens);

const languageLens = lensProp("language");
const setLanguage = set(languageLens);
export const getLanguage = view(languageLens);

export const getProjectKey = view(lensPath(["project", "projectKey"]));
export const getProgramKey = view(lensPath(["project", "programKey"]));
export const getProjectId = view(lensPath(["project", "projectId"]));
export const getProjectLogoUri = view(lensPath(["project", "logoUri"]));
export const getProjectRedirectUri = view(lensPath(["project", "redirectUri"]));
export const getProjectTermsUri = view(lensPath(["project", "termsUri"]));
export const getProjectActive = view(lensPath(["project", "active"]));
export const getDefaultLibraryId = either(
  view(lensPath(["project", "defaultLibraryId"])),
  view(lensPath(["organization", "organizationId"])),
);
export const getProjectHideCoverImageUpload = view(
  lensPath(["project", "hideCoverImageUpload"]),
);
export const getProjectLanguages = view(lensPath(["project", "languages"]));
export const getProjectDefaultPubDateFormat = view(
  lensPath(["project", "defaultPublicationDateFormat"]),
);

const submissionTypesLens = lensPath(["project", "submissionTypes"]);
export const getSubmissionTypes = pipe(
  view(submissionTypesLens),
  defaultTo([]),
);

const projectLibrariesLens = lensPath(["project", "libraryOptions"]);
export const getProjectLibraries = pipe(
  view(projectLibrariesLens),
  defaultTo([]),
);

const optInsLens = lensPath(["project", "optIns"]);
export const getOptIns = pipe(view(optInsLens), defaultTo([]));

const audiencesLens = lensPath(["project", "audiences"]);
export const getAudiences = pipe(view(audiencesLens), defaultTo([]));

const subProjectsLens = lensPath(["project", "subProjects"]);

const customDropdownItemsLens = lensPath(["project", "customDropdownItems"]);

export const getSubProjects = pipe(view(subProjectsLens), defaultTo([]));

export const getCustomDropdownItems = pipe(
  view(customDropdownItemsLens),
  defaultTo([]),
);

const fieldOptionsLens = lensPath(["project", "fieldOptions"]);
export const getFieldOptions = pipe(view(fieldOptionsLens), defaultTo({}));
export const setFieldOptions = set(fieldOptionsLens);

const categoriesLens = lensPath(["project", "categories"]);
export const getCategories = view(categoriesLens);
export const getCategoryForId = (categoryId, categories) =>
  find(propEq("categoryId", categoryId), categories);

const organizationLens = lensProp("organization");
const setOrganization = set(organizationLens);
export const getOrganization = view(organizationLens);

export const getOrganizationAlias = view(lensPath(["organization", "alias"]));
export const getOrganizationId = view(
  lensPath(["organization", "organizationId"]),
);

const collectPurchaseLinkLens = lensPath(["project", "collectPurchaseLink"]);
export const getCollectPurchaseLink = view(collectPurchaseLinkLens);

const collectPublicationYearLens = lensPath([
  "project",
  "collectPublicationYear",
]);
export const getCollectPublicationYear = view(collectPublicationYearLens);

const appDataLoaded = ({ organization, project }, state) =>
  pipe(setProject(project), setOrganization(organization))(state);

const applicationReducer = (state = initialState, action) => {
  switch (action.type) {
    case APP_STARTED:
      return setLanguage(action.language, state);
    case APP_ERROR:
      return setError(action.error, state);
    case APP_DATA_LOADED:
      return appDataLoaded(action.data, state);
    default:
      return state;
  }
};

export default applicationReducer;
